import {SET_PERSONS_INFO} from '../constants/action-types';

export const setPersonsInfo = (person) => {
    return dispatch => {
        dispatch({type: SET_PERSONS_INFO, payload: person});
    };
};

